import React from 'react';
import {Col} from 'react-grid-system';
import AppIcon from './headerNav/AppIcon';
import HowToInstallAppButton from './headerNav/HowToInstallAppButton';
import FaqButton from "./headerNav/FaqButton";
import QuickGuideButton from "./headerNav/QuickGuideButton";

interface States {
}

interface Props {
}

class HeaderNav extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div
                style={{display: "contents"}}>
                <AppIcon/>
                <HowToInstallAppButton/>
                <FaqButton/>
                <QuickGuideButton/>
            </div>
        )
    }
}

export default HeaderNav;
